"use client";

import { c as _c } from "react/compiler-runtime";
import CommonPagesections from "../../common/CommonPagesections";
export default function ProductSections(t0) {
  const $ = _c(3);
  const {
    sections,
    labelMap
  } = t0;
  let t1;
  if ($[0] !== labelMap || $[1] !== sections) {
    t1 = <CommonPagesections sections={sections} labelMap={labelMap} />;
    $[0] = labelMap;
    $[1] = sections;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}